<template>
  <div>
	<div class="data6">
		<div class="data6Left">
			<div class="data6LeftTil">
				交互新体验·高效工作平台
			</div>
			<div class="data6LeftBox">
				<div class="data6LeftFor" v-for="(item,index) in byzlList" :key="index">
					<div class="data6LeftForImg">
						<img :src="item.img" />
					</div>
					<div class="data6LeftForName">
						{{item.name}}
					</div>
					<div class="data6LeftForCen">
						{{item.cen}}
					</div>
				</div>
			</div>
		</div>
		<div class="data6Right">
			<img src="@/assets/product/page2/czjyZlys.png" />
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {
		byzlList: [{
				img: require('@/assets/product/page6/znpb.png'),
				name: '智能平板 全新交互',
				cen: '- 智能启动/关机/匹配多型号内镜- 人脸识别登陆/语音控制'
			},
			{
				img: require('@/assets/product/page6/ssjk.png'),
				name: '实时监控 辅助诊断',
				cen: '- 手术过程实时辅助诊断- 内镜医生的得力助手'
			},
			{
					img: require('@/assets/product/page6/shm.png'),
					name: '双画面 双光显示',
					cen: '- 支持外部设备接入- 两种染色模式同时观察- 冻结时另一画面实时观察'
				},
				{
					img: require('@/assets/product/page6/jgcs.png'),
					name: '激光传输 无线供电',
					cen: '- 更高速率传输，呈现更多细节- 实现电气隔离，避免漏电风险- 免受高频电刀或周边设备影响'
				},
		]
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.data6{
	display: flex;
	padding-bottom: 150px;
	.data6Left{
		flex:1;
		padding-left: 200px;
		.data6LeftTil{
			font-size: 45px;
			
			font-weight: bold;
			color: #000000;
			margin-bottom: 70px;
		}
		.data6LeftBox{
			display: flex;
			flex-wrap: wrap;
			width: 100%;
			.data6LeftFor{
				width: calc(49% - 40px);
				padding: 0 20px;
				margin-bottom: 70px;
				.data6LeftForImg{
					margin-bottom: 42px;
					img{
						width: 70px;
						height: 70px;
					}
				}
				.data6LeftForName{
					margin-bottom: 32px;
					font-size: 26px;
					
					font-weight: 400;
					color: #000000;
				}
				.data6LeftForCen{
					font-size: 18px;
					
					font-weight: 300;
					color: #000000;
				}
			}
		}
	}
	.data6Right{
		flex:1;
		img{
			width: 100%;
			height: 600px;
			object-fit: cover;
		}
	}
}
</style>
